import React, {useState} from 'react';
import { Modal, Image, Button } from 'react-bootstrap';
import SalirIcon from '../../../../Images/salir.svg';
import SuccessIcon from '../../../../Images/tarjeta_agregada.svg';
import FailedIcon from '../../../../Images/tarjeta_no_valida.svg';
import { Bounce } from 'react-activity';

export const ModalSuccess = (props) => {
  const [showModalContact, setShowModalContact] = useState(false);

  return(
    <>
      <Modal
        size="sm"
        show={props.show}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header className='custom-header-settings2' style={{height: '30px'}}>
          <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '0px'}}>
            <Image src={SalirIcon} onClick={() => {props.variant === 'success' ? props.closeModal() : props.handleCloseModal() }} alt="X" style={{cursor: 'pointer'}}/>
          </div>
        </Modal.Header>
        {
          props.variant === 'success' ? 
          <Modal.Body style={{padding: '30px 15px 70px'}}>
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <Image src={SuccessIcon} width={105} height={71}/>
            </div>
            <div style={{textAlign: 'center', marginTop: '21px'}}>
              <span>{props.traductions.Card.enabled.modalRegister.success.title}</span>
            </div>
            <div style={{textAlign: 'center', marginTop: '19px'}}>
              <span>{props.traductions.Card.enabled.modalRegister.success.subtitle}</span>
            </div>
            <div style={{textAlign: 'center', marginTop: '25px'}}>
              <Button onClick={() => props.closeModal()} className='btn-block-card'>{props.traductions.Card.enabled.modalRegister.success.btn_init}</Button>
            </div>
          </Modal.Body>
            :
          <Modal.Body style={{padding: '30px 10px 30px'}}>
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <Image src={FailedIcon} width={105} height={71}/>
            </div>
            <div style={{textAlign: 'center', marginTop: '21px'}}>
              <span>{props.traductions.Card.enabled.modalRegister.failed.title}</span>
            </div>
            <div style={{textAlign: 'center', marginTop: '19px'}}>
              <span style={{whiteSpace: 'pre-wrap'}}>{props.traductions.Card.enabled.modalRegister.failed.msg}</span>
            </div>
            <div style={{display:'flex', justifyContent: 'center', marginTop: '19px'}}>
              <Button
                className='gray-btn'
                style={{width: '184px'}}
                onClick={() => props.handleCloseModal()}
              >
                {props.traductions.Card.enabled.modalRegister.failed.btn_back}
              </Button>
            </div>
            <div style={{textAlign: 'center', marginTop: '25px'}}>
              <Button onClick={() => {props.handleCloseModal(); setShowModalContact(true)}} style={{width: '300px'}} className='btn-block-card'>{props.traductions.Card.enabled.modalRegister.failed.btn_contact}</Button>
            </div>
          </Modal.Body>
        }
      </Modal>
      <Modal
      id="modal_reposition"
      size="lg"
      show={showModalContact}
      aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header  style={{display: 'flex', flexDirection: 'column'}} className='custom-header-settings'>
          <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
            <Image src={SalirIcon} onClick={() => setShowModalContact(false)} alt="X" style={{cursor: 'pointer'}}/>
          </div>
        </Modal.Header>
        <Modal.Body style={{padding: '10px 60px 50px'}}>
          <div style={{textAlign: 'center'}}>
            <span className='text-call-number'>{props.traductions.Card.enabled.modalCardReplacement.L_body}</span>
          </div>
          <div style={{textAlign: 'center', marginTop: '30px'}}>
            <span className='phone-number-blue'>+52 81 9034 9039</span>
          </div>
          <div style={{textAlign: 'center', marginTop: '30px'}}>
            <Button onClick={() => setShowModalContact(false)} className='ghost-cancelar'>{props.traductions.Card.enabled.modalCardReplacement.L_cancel}</Button>
          </div>
        </Modal.Body>
      </Modal>
    </>

  )

}